import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Icon } from "@vds/icons";
import { UnorderedList, ListItem } from "@vds/lists";
import { Body } from "@vds/typography";

const CollapsibleList = ({
  heading,
  headingSize = "large",
  bodySize = "bodyLarge",
  items,
  gap,
  ...props
}) => {
  const [openItems, setOpenItems] = useState([]);

  useEffect(() => {
    let data = [];
    for (const item in items) {
      data.push(!!item?.openByDefault);
    }
    setOpenItems(data);
  }, [items]);

  const isOpen = (index) => !!openItems?.length && openItems[index];

  const getListItems = () => {
    return items.map((item, index) => (
      <StyledListItem
        size={bodySize}
        spacing="standard"
        key={item.title}
        gap={gap}
      >
        <Body size="small">
          {`${item.title} `}
          {!!item?.listItems?.length && (
            <IconWrapper onClick={() => toggleItem(index)}>
              <Icon
                size="small"
                name={isOpen(index) ? "up-caret" : "down-caret"}
              />
            </IconWrapper>
          )}
        </Body>
        {!!item?.listItems?.length && isOpen(index) && (
          <UnorderedList>
            {item.listItems.map((subItem, idx) => (
              <StyledListItem key={idx} size="bodySmall" gap={gap}>
                <div dangerouslySetInnerHTML={{ __html: subItem }} />
              </StyledListItem>
            ))}
          </UnorderedList>
        )}
      </StyledListItem>
    ));
  };

  const toggleItem = (index) => {
    const data = [...openItems];
    data[index] = !openItems[index];
    setOpenItems(data);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Heading gap={gap}>
        <Body size={headingSize} bold>
          {heading}
        </Body>
      </Heading>
      <UnorderedList>{getListItems()}</UnorderedList>
    </div>
  );
};

const IconWrapper = styled.span`
  svg {
    vertical-align: bottom;
  }
`;

const Heading = styled.div`
  padding-bottom: ${(props) => props?.gap ?? "1rem"};
  li {
    position: relative;
    right: 16px;
  }
`;

const StyledListItem = styled(ListItem)`
  padding-top: ${(props) => props?.gap ?? "1rem"};
  text-wrap: balance;
  ul {
    li {
      &:before {
        padding-left: 0px !important;
      }
    }
  }
`;

export default CollapsibleList;
